module.exports = __webpack_public_path__ + "img/改革后.ffe02805.png";